module.exports = __webpack_public_path__ + "static/posts-mobile-bb9ac7ec19d054f9e101139a1541778a.png";